import React from 'react';
import StarRating from './star-rating';
import { styled } from 'themes';
import { useTranslation } from 'react-i18next';

export const RATING_PROPS = {
  EXECUTION: 'ratingExecution',
  COMMUNCATION: 'ratingCommunication',
  PLANNING: 'ratingPlanning',
};
export const YEP_RATING_PROPS = [
  RATING_PROPS.EXECUTION,
  RATING_PROPS.COMMUNCATION,
  RATING_PROPS.PLANNING,
];

const Ratings = props => {
  const { t } = useTranslation();
  const { payload } = props;
  const ratings = YEP_RATING_PROPS.map(ratingProp => {
    return {
      text: t(`component--public-activity-item.rating--${ratingProp}`),
      rating: payload[ratingProp],
    };
  }).filter(({ rating }) => rating > 0);

  return (
    <>
      {ratings.map(r => {
        if (!r.text) return;
        return (
          <React.Fragment key={r.text}>
            <Wrapper key={r.text}>
              <Text>{r.text}</Text>
              <StarRating rating={r.rating} size={18} />
            </Wrapper>
          </React.Fragment>
        );
      })}
    </>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Text = styled.p`
  font-size: 1.5rem;
`;

export default Ratings;
